const OUTLINE_BORDER = "1px solid rgba(0, 0, 0, 0.23)";

export const styles = {
  removeArrow: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none",
    },
    "& input[type=number]": { MozAppearance: "textfield" },
  },
  selectDropdown: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.8125rem",
    color: "#364152",
    fontWeight: "400",
    borderRadius: "12px",
    "& > div": {
      background: "none",
      color: "black",
      borderRadius: "12px",
      fontSize: "0.8125rem",
      fontWeight: "400",
    },
    "& fieldset": {
      color: "black",
      borderRadius: "8px",
    },
  },
  // Banner column: a square dropzone so the image box always has the same
  // width and height, whatever the image or the fields column height.
  bannerColumn: {
    display: "flex",
    flexDirection: "column",
  },
  bannerDropzone: {
    width: "100%",
    aspectRatio: "1 / 1",
    display: "flex",
    "& > *": {
      flex: 1,
      minHeight: 0,
    },
  },
  // Fields column: two columns on tablet+, single column on phones.
  fieldsColumn: {
    display: "flex",
    flexDirection: "column",
  },
  fieldsGrid: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
    gap: "24px",
    alignItems: "start",
    alignContent: "start",
  },
  fieldCell: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    minHeight: 0,
    width: "100%",
  },
  fullRow: {
    gridColumn: "1 / -1",
  },
  // Value input with the unit dropdown attached to its right edge.
  attachedInput: {
    "&.MuiInputBase-adornedEnd": { pr: 0 },
    "& input": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  // `height: auto` (not 100%) so the flex `stretch` chain reaches the select.
  attachedAdornment: {
    height: "auto",
    maxHeight: "none",
    alignSelf: "stretch",
    alignItems: "stretch",
    ml: 0,
  },
  attachedSelect: {
    minWidth: 72,
    alignItems: "stretch",
    borderLeft: OUTLINE_BORDER,
    "& .MuiSelect-select": {
      height: "auto",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      py: 0,
      pl: 1.5,
      pr: "30px !important",
      fontSize: "0.9375rem",
      fontWeight: 600,
      color: "#364152",
      backgroundColor: "transparent",
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent",
    },
    "& .MuiSelect-icon": {
      right: 6,
    },
  },
  descriptionInput: {
    "& textarea": {
      resize: "none",
      lineHeight: 1.5,
    },
  },
  footerRow: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "16px",
  },
};
